import { render, staticRenderFns } from "./VirtualContractsForVehicleWidget.vue?vue&type=template&id=0893626d&scoped=true&"
import script from "./VirtualContractsForVehicleWidget.vue?vue&type=script&lang=js&"
export * from "./VirtualContractsForVehicleWidget.vue?vue&type=script&lang=js&"
import style0 from "./VirtualContractsForVehicleWidget.vue?vue&type=style&index=0&id=0893626d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0893626d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0893626d')) {
      api.createRecord('0893626d', component.options)
    } else {
      api.reload('0893626d', component.options)
    }
    module.hot.accept("./VirtualContractsForVehicleWidget.vue?vue&type=template&id=0893626d&scoped=true&", function () {
      api.rerender('0893626d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VirtualContractsForVehicleWidget.vue"
export default component.exports